<template>
  <v-flex xs12>
    <PlayerSettings key="ps" v-if="!file && !stream && !quality" :stream.sync="stream" :file.sync="file" :quality.sync="quality"/>
    <QualitySettings key="qs" v-if="quality" :quality.sync="quality"/>
  </v-flex>
</template>

<script>
/* eslint func-names: ["error", "never"] */
/* eslint object-shorthand: 0 */
import PlayerSettings from './PlayerSettings.vue';
import QualitySettings from './QualitySettings.vue';

export default {
  name: 'Controls',
  data() {
    return {
      file: false,
      stream: false,
      quality: false,
    };
  },
  components: {
    PlayerSettings,
    QualitySettings,
  },
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: all .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
